import Icon from '@app/components/shared/icon.component';
import { dateTimeFormatOptions } from '@app/constants';
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, Typography } from '@material-ui/core';
import React from 'react';
import { FormattedDate, InjectedIntlProps, injectIntl } from 'react-intl';

interface IFedExNativeTrackngRangeImportAccordion extends InjectedIntlProps {
	fedexNativeLastRangeDate: Date;
	importTrackingRange: () => void;
}

class FedExNativeTrackngRangeImportAccordion extends React.Component<IFedExNativeTrackngRangeImportAccordion> {
	constructor(props: any) {
		super(props);
	}
	public render() {
		return (
			<>
				<Accordion defaultExpanded={true}>
					<AccordionSummary expandIcon={<Icon name='chevron-down' />}>
						<Grid container={true} direction='row' justifyContent='space-evenly'>
							<Grid item={true} xs={12}>
								<Typography variant='h6' color='inherit'>
									{this.props.intl.formatMessage({
										id: 'app.admin.carrier-configuration-accordion-Tracking-Range-label',
									})}
								</Typography>
							</Grid>
						</Grid>
					</AccordionSummary>
					<AccordionDetails style={{ maxHeight: '186px !important' }}>
						<Grid container={true}>
							<Grid item={true} lg={12}>
								<Grid container={true} direction='row' justifyContent='space-evenly' alignItems='center' spacing={2}>
									<Grid item={true} xs={12} md={2} lg={4}>
										<Typography variant='subtitle2' color='inherit' className='pl-2'>
											{this.props.intl.formatMessage({
												id: 'app.admin.carrier-details-list-tracking-range-last-imported-date',
											})}
										</Typography>
									</Grid>
									<Grid item={true} xs={12} md={10} lg={8}>
										<Typography variant='subtitle2' color='inherit'>
											{this.props.fedexNativeLastRangeDate !== null ? (
												<FormattedDate {...dateTimeFormatOptions} value={this.props.fedexNativeLastRangeDate} />
											) : (
												this.props.intl.formatMessage({
													id: 'app.common.not-applicable-value',
												})
											)}
										</Typography>
									</Grid>
								</Grid>

								<Grid container={true} direction='row' justifyContent='space-evenly' alignItems='center' spacing={2}>
									<Grid item={true} className='buttons'>
										<Button color='secondary' onClick={() => this.props.importTrackingRange()}>
											{this.props.intl.formatMessage({ id: 'app.admin.carrier-import-tracking-range-button' })}
										</Button>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</AccordionDetails>
				</Accordion>
			</>
		);
	}
}

export default injectIntl(FedExNativeTrackngRangeImportAccordion);



// WEBPACK FOOTER //
// ./src/components/admin/carriers/fedex-native-tracking-range-import-accordion.tsx